<template>
<Tooltip transfer :content="validMsg" theme="err" :disabled="!(validErr&&validErrMsgTip)"  class="ivu-table-cell-tooltip">
    <div  :class="getEditClass" @mouseenter="validErrMsgTipIn" @mouseleave="validErrMsgTipOut">
        <template>
            <div :class="[prefixCls + '-rel']">
                <template>
                    <Tooltip transfer :content="showContent" :disabled="!showTooltip" class="ivu-table-cell-tooltip">
                        <p ref="content" @mouseenter="handleTooltipIn" @mouseleave="handleTooltipOut" class="ivu-table-cell-tooltip-content">{{ showContent }}</p>
                    </Tooltip>
                </template>
            </div>
            <template> 
              <div :class="[prefixCls + '-popper']"
                  v-if="visible">
                  <div :class="[prefixCls + '-content']">
                      <user isFocused 
                          ref="user"
                          @on-blur="handleBlur" 
                          @onChange="change" 
                          :disabled="editCfg.disabled"
                          v-model="selectData" 
                          :isQueryIdataUser="editCfg.isQueryIdataUser"
                          :valueAttr="editCfg.valueAttr"></user>
                  </div>
              </div> 
            </template>
        </template>
    </div>
</Tooltip>
</template>
<script>
import Tooltip from '../../tooltip/tooltip.vue';
const prefixCls = "table-edit";
export default {
  name: "plugUser",
  components:{Tooltip},
  computed: {
    getEditClass() {
      return [
        `${this.prefixCls}`,
        {
            [`${this.prefixCls}-always`]: (this.editAlways||this.always)&&!this.visible,
            [`${this.prefixCls}-disabled`]:this.getDisabled(),
            [`${this.prefixCls}-cell-valid-err`]: this.validErr === true&&!this.visible
        }
      ];
    }
  },
  props: {
    content: {
      type: [String, Number],
      default: ""
    },
    col: [String, Number, Object],
    row: [String, Number, Object],
    editCfg: Object,
    dropIndex: Number,
    dropInit: Boolean,
    disabled: {
      type: Boolean,
      default: false
    },
    visible: {
      type: Boolean,
      default: false
    },
    always: {
      type: Boolean,
      default: false
    },
    validErr:{
      type: Boolean,
      default: false
    },
    validMsg:String,
    editAlways:{
      type: Boolean,
      default: false
    },
    maxWidth: {
      type: [String, Number]
    }
  },
  data() {
    return {
      prefixCls: prefixCls,
      selectData: "",
      showContent:"",
      showTooltip: false,
      validErrMsgTip:false
    };
  },
  watch: {
  },
  methods: {
    handleBlur() {
      this.$emit("onChangeShowEdit", false,this.showContent);
    },
    change(value,item,queryFrom) {
        let showContent=item.ucn
        //调用显示前方法，有的地方只显示工号
        if(this.editCfg.onShowFormat){
            showContent=this.editCfg.onShowFormat(value,item,queryFrom)
        }
        this.showContent=showContent
        this.$emit("onChange", value, this.col,item);
    },
    handleTooltipIn () {
      const $content = this.$refs.content;
      this.showTooltip = $content.scrollWidth > $content.offsetWidth;
    },
    handleTooltipOut () {
      this.showTooltip = false;
    },
    validErrMsgTipIn(){
      this.validErrMsgTip=true
    },
    validErrMsgTipOut(){
      this.validErrMsgTip=false
    },
    getDisabled(item) {
       let myDisabled=this.editCfg.setDisabled
        ? this.editCfg.setDisabled(this.col, this.row, this.editCfg)
        : this.editCfg.disabled;
        if(myDisabled){
            this.$emit("setColEditDisabled", myDisabled);
        }
        return myDisabled
    },
  },
  mounted() {
    this.showContent = this.content;
  }
};
</script>




// WEBPACK FOOTER //
// src/components/common/table/plug/user.vue